import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../../models/hooks/appStateHooks';

export function useAutomationTemplateCreateForResourceSelectorMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.ICreateAutomationsResult) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			resourceSelectorId,
			request,
			impersonationContext,
		}: {
			resourceSelectorId: Api.ResourceSelectorId;
			request: Api.ICreateAutomationForResourceSelectorRequest;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.ICreateAutomationsResult>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `automation/ResourceSelector/${encodeURIComponent(resourceSelectorId)}`,
					impersonationContext,
				}),
				'POST',
				request
			);
		},
		onSuccess,
		onError,
	});
}
